import styled from 'styled-components';

export const SuccesPage = styled.div`
  position: fixed;
  top:0;
  left:0;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  background: rgba(24, 24, 40, .7);
`;

export const Container = styled.div`
  display: block;
  width: 80vw;
  margin: 0 auto;
  @media (min-width: 768px) {
    width: 60vw;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background: rgb(46, 46, 78);
  padding:40px 0 80px;
`;

export const SuccessImg = styled.img`
  display: block;
  width: 150;
  height: 180px;
  margin-bottom: 34px;
  @media (min-width: 768px) {
  width: 196.35px;
  height: 234px;
}
`;

export const Title = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 36px;
  line-height: 44px;
  color: #ffffff;
  margin-bottom: 10px;
  text-align: center;
  @media (min-width: 768px) {
    margin-bottom: 22px;
  }
`;

export const Description = styled.p`
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
   text-align: center;
  letter-spacing: 0.1px;
  color: #aaabbc;
  margin-bottom: 10px;
  opacity: 0.7;
 
  @media (min-width: 768px) {
    margin-bottom: 30px;
}
`;

export const GoBackButton = styled.button`
 padding: 20px 40px;
  border-radius: 4px;
  background: ${({ hovered }: any) =>
    hovered ? 'transparent' : '#2b70fa'};
  font-family: 'Gilroy';
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  border: 1px solid #2b70fa;
`;
